export var RadiusType;
(function (RadiusType) {
    RadiusType["Joint"] = "joint";
    RadiusType["Separate"] = "separate";
})(RadiusType || (RadiusType = {}));
export var PaddingType;
(function (PaddingType) {
    PaddingType["Joint"] = "joint";
    PaddingType["Separate"] = "separate";
})(PaddingType || (PaddingType = {}));
export var FilterType;
(function (FilterType) {
    FilterType["Blur"] = "blur";
    FilterType["Contrast"] = "contrast";
    FilterType["Invert"] = "invert";
    FilterType["Grayscale"] = "grayscale";
    FilterType["Saturation"] = "saturate";
    FilterType["Sepia"] = "sepia";
})(FilterType || (FilterType = {}));
export var FilterUnit;
(function (FilterUnit) {
    FilterUnit["Length"] = "px";
    FilterUnit["Percentage"] = "%";
})(FilterUnit || (FilterUnit = {}));
export const FILTER_MAP = {
    [FilterType.Blur]: {
        name: 'Blur',
        icon: 'filter-blur',
        nuiIcon: 'blur_circular',
        unit: FilterUnit.Length,
        min: 0,
        max: 100
    },
    [FilterType.Contrast]: {
        name: 'Contrast',
        icon: 'filter-contrast',
        nuiIcon: 'contrast',
        unit: FilterUnit.Percentage,
        min: 0,
        max: 200,
        default: 100
    },
    [FilterType.Invert]: {
        name: 'Invert',
        icon: 'filter-invert',
        nuiIcon: 'invert_colors',
        unit: FilterUnit.Percentage,
        min: 0,
        max: 100
    },
    [FilterType.Grayscale]: {
        name: 'Grayscale',
        icon: 'filter-grayscale',
        nuiIcon: 'stroke_full',
        unit: FilterUnit.Percentage,
        min: 0,
        max: 100
    },
    [FilterType.Saturation]: {
        name: 'Saturation',
        icon: 'filter-saturate',
        nuiIcon: 'animation',
        unit: FilterUnit.Percentage,
        min: 0,
        max: 200,
        default: 100
    },
    [FilterType.Sepia]: {
        name: 'Sepia',
        icon: 'filter-sepia',
        nuiIcon: 'filter_vintage',
        unit: FilterUnit.Percentage,
        min: 0,
        max: 100
    }
};
// Construct an array of FilterInfos with added ids for easy lookup and rendering.
export const FILTER_LIST = Object.entries(FILTER_MAP).reduce((memo, [key, filter]) => [...memo, Object.assign({ id: key }, filter)], []);
